import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Stack, styled, Typography } from '@mui/material'
import type { FC } from 'react'
import type { To } from 'react-router'

import { COLORS, ICONS } from '../../constants'
import { serratedEdgeVerticalCss } from '../../styles'
import { unit } from '../../utils'
import { Chip } from '../data-display'
import { LinkUnstyled } from '../navigation'

export interface CouponProps {
  caption: string
  icon: string
  link: {
    label: string
    title: string
    to: To
  }
  status: {
    label: string
    value: 'Used' | 'Inactive' | 'Valid'
  }
  title: string
}

export const Coupon: FC<CouponProps> = ({ caption, link, icon, status, title }) => {
  return (
    <Container to={link.to}>
      <Header>
        <Stack direction='column' gap={unit(1)}>
          <Caption variant='labelExtraSmall'>{caption}</Caption>
          <Typography variant='headlineExtraSmall'>{title}</Typography>
        </Stack>
        <Box>
          <Chip component='coupon' text={status.label} variant={status.value} />
        </Box>
      </Header>
      <Content>
        <Stack gap={unit(4)}>
          <Stack sx={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: unit(1.5) }}>
            <Typography variant='titleS'>{link.label}</Typography>
            <FontAwesomeIcon icon={ICONS.fasArrowRight} fontSize={unit(4)} />
          </Stack>
        </Stack>

        <Box component='img' alt='' src={icon} width={unit(23)} height={unit(20)} />
      </Content>
    </Container>
  )
}

const Container = styled(LinkUnstyled)`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  min-height: ${unit(42)};
  padding: ${unit(5)};
  gap: ${unit(4)};
  background-color: ${COLORS.ruoho['62%']};

  &:hover,
  &:focus {
    background-color: ${COLORS.ruoho['20%']};
  }

  &::after {
    position: absolute;
    top: 0;
    right: -${unit(1)};
    content: '';
    width: ${unit(1)};
    height: 100%;
    background-color: ${COLORS.ruoho['60%']};
    ${serratedEdgeVerticalCss(2)};
  }
`

const Content = styled(Stack)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  gap: ${unit(2.5)};
  width: 100%;
`

const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: ${unit(1.5)};
`

const Caption = styled(Typography)`
  line-height: ${unit(4.5)};
  color: ${COLORS.sammal};
  texttransform: uppercase;
`
